import React from "react";

const Textarea = ({
  type = "text",
  name,
  value,
  onChange,
  rows = 3,
  placeholder,
  disabled,
  className
}) => {
  if (type === "textarea") {
    return (
      <div className="textarea_container">
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          rows={rows}
          placeholder={placeholder}
          disabled={disabled}
          className={`w-100 ${className}`}
        />
      </div>
    );
  }

  return (
    <div className="textarea_container">
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-100 ${className}`}
      />
    </div>
  );
};

export default Textarea;
